// src/utils/translateServer.ts
import { Language } from "@/translations/supportedLanguages";
import { loadTranslations } from "./loadTranslations";

export async function getTranslations(
  lang: Language,
  clientMessages?: Record<string, string>
): Promise<Record<string, string>> {
  if (typeof window !== "undefined" && clientMessages) {
    return clientMessages;
  }
  return await loadTranslations(lang);
}
